<template>
  <div class="p-2">
    <RestaurantPosTableNode
        v-for="section in sections"
        :key="section.id"
        :node="section"
        @select="$emit('select', $event)"
    />
    <p v-if="!sections.length && !loading" class="text-center text-muted my-5">No tables found</p>
    <Loader v-if="loading"/>
  </div>
</template>

<script setup>
import {computed, inject, onMounted, ref} from 'vue';
import {useRoute} from 'vue-router';
import RestaurantPosTableNode from '@/components/molecule/company/pos-invoice/RestaurantPosTableNode.vue';
import Loader from '@/components/atom/LoaderComponent';
import handleHospital from '@/services/modules/hospital';

defineEmits(['select']);

const route = useRoute();
const showError = inject('showError');
const {fetchRestaurantPosTables} = handleHospital();

const companyId = computed(() => route.params.companyId);

const sections = ref([]);
const loading = ref(false);

onMounted(async () => {
  await getPosTables();
});

const getPosTables = async () => {
  const query = `?company_id=${companyId.value}`;
  loading.value = true;
  try {
    let res = await fetchRestaurantPosTables(query);
    if (!res.status) {
      sections.value = [];
      return;
    }
    sections.value = res.data;
  } catch (err) {
    if (!err.response) {
      showError('Something is wrong. Check your connectivity!!');
      return;
    }
    showError(err.response.message);
  } finally {
    loading.value = false;
  }
};

defineExpose({getPosTables});
</script>